<template>
  <div class="bar" :class="'bar-' + percentage">
    <div class="bar-fg"></div>
    <div class="bar-label">{{ percentage }}%</div>
  </div>
</template>
<script>
export default {
  name: 'Bar',
  props: ['className', 'percentage']
}
</script>
